require('../../search/_submit');

jQuery(document).ready(() => {
  $('.select-hymnal').select2({
    placeholder: 'Hymnals / Resources',
    minimumResultsForSearch: Infinity
  });
});
